import React, { PropTypes, Component } from 'react';
import styles from 'styled-components';

import Notifications from 'react-notification-system-redux';
import { NitroSnackbar } from 'nitro-components';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as serverActions from '../../server/actions';
import constants from '@src/constants';

const Article = styles.article`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

class CanViewContainer extends Component {
  render() {
    const { notifications, server, serverActions, location } = this.props;
    const { error, message } = server;

    const { clearServerError } = serverActions;

    // console.log("canview", this.props);

    return (
      <Article>
        {this.props.children}

        {/* TODO - The current implementation of NitroSnackbar is
            limited in the way that it only allow display one error
            message at a time. disable snackbar for insights page now
            until find a better alternative
         */}
        {location.pathname !== '/insights' &&
          constants.SNABCKBAR_ENABLED === 'true' && (
            <NitroSnackbar
              open={error}
              message={message}
              innerRef={node => (this.innerRef = node)}
              autoHideDuration={10000}
              onRequestClose={clearServerError}
            />
          )}

        <Notifications
          notifications={notifications}
          // To disable all inline styles, just pass false to the prop style
          // eslint-disable-next-line react/style-prop-object
          style={false}
        />
      </Article>
    );
  }
}

CanViewContainer.propTypes = {
  children: PropTypes.node,
  notifications: PropTypes.array,
  server: PropTypes.object.isRequired,
  serverActions: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  server: state.server,
  notifications: state.notifications,
});

const mapDispatchToProps = dispatch => ({
  serverActions: bindActionCreators(serverActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CanViewContainer);



// WEBPACK FOOTER //
// ./src/layouts/global/CanViewContainer.js